import {theme} from "../../../../utils";


export const styles = {
    dialogTitle: {
        ...theme.typography.opticianBodyRegular,
        flex: 1,
        fontSize: "24px",
        lineHeight: "24px",
    },
    dialogSubTitle: {
        ...theme.typography.poppinsBodyRegular,
        color: "#484A4C",
        fontSize: "16px",
        mt: '30px'
    },
    rowAlignBtnWrapper: {
        color: "#000",
        width: "197px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px'
    },
}

export interface ILogoutDialogProps {
    onCloseLogout?: () => void;
    showDialog: boolean
}